import React from 'react';

const PaymentMethods = () => {
   return (
      <>
         <div className="bg-slate-900/50 backdrop-blur-sm rounded-2xl border border-slate-800 p-5">
            <h3 className="text-sm font-semibold text-white mb-4">Payment Split</h3>
            <div className="grid grid-cols-2 gap-4">
               <div>
                  <div className="flex items-center justify-between mb-1.5">
                     <span className="text-xs text-slate-400">💵 Cash</span>
                     <span className="text-xs font-medium text-emerald-400">₹0</span>
                  </div>
                  <input
                     type="number"
                     placeholder="0.00"
                     className="w-full bg-slate-800/50 border border-slate-700 rounded-lg px-3 py-2 text-sm text-white text-right focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all"
                  />
               </div>
               <div>
                  <div className="flex items-center justify-between mb-1.5">
                     <span className="text-xs text-slate-400">🏦 Bank</span>
                     <span className="text-xs font-medium text-blue-400">₹0</span>
                  </div>
                  <input
                     type="number"
                     placeholder="0.00"
                     className="w-full bg-slate-800/50 border border-slate-700 rounded-lg px-3 py-2 text-sm text-white text-right focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
               </div>
               <div>
                  <div className="flex items-center justify-between mb-1.5">
                     <span className="text-xs text-slate-400">📱 GPay</span>
                     <span className="text-xs font-medium text-purple-400">₹0</span>
                  </div>
                  <input
                     type="number"
                     placeholder="0.00"
                     className="w-full bg-slate-800/50 border border-slate-700 rounded-lg px-3 py-2 text-sm text-white text-right focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all"
                  />
               </div>
               <div>
                  <div className="flex items-center justify-between mb-1.5">
                     <span className="text-xs text-slate-400">💳 Other</span>
                     <span className="text-xs font-medium text-orange-400">₹0</span>
                  </div>
                  <input
                     type="number"
                     placeholder="0.00"
                     className="w-full bg-slate-800/50 border border-slate-700 rounded-lg px-3 py-2 text-sm text-white text-right focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all"
                  />
               </div>
            </div>
         </div>
      </>
   );
};

export default PaymentMethods;
